import { Label } from 'app/KinerjaKSPage/components/CardDataConfirmation/Label'

import type { LabelProps } from 'app/KinerjaKSPage/components/CardDataConfirmation/Label'
import type { FC } from 'react'

type Props = LabelProps

export const DetailContentListValue: FC<Props> = (props) => {
  return <Label endsWithDot {...props} />
}
